import isEmpty from 'lodash/isEmpty';

export default function validateInput(data) {
    let errors = {};
    return {
        errors,
        isValid: isEmpty(errors)
    };
}